import { useTranslation } from "react-i18next";
//import { Separator } from "@/components/ui/separator";
import { PaymentDetailsSectionProps } from "../types";
import { InfoSection, InfoRow } from "@/components/ui/data-display";
import { CurrencyAmount } from "@/components/ui/CurrencyAmount";

export function PaymentDetailsSection({
  amount,
  currency,
}: // tip,
PaymentDetailsSectionProps) {
  const { t } = useTranslation();
  // const totalPayment = amount + tip;

  return (
    <InfoSection title={t("payment.details")}>
      <InfoRow
        label={t("payment.amount")}
        value={<CurrencyAmount amount={amount} currency={currency} />}
        description={{
          label: t("payment.excludingTip"),
        }}
        isNumeric
      />
      {/* <InfoRow 
        label={t("payment.tip")} 
        value={formatAmount(tip, currency)} 
        isNumeric
      /> 
      <Separator className="my-2" />
      <InfoRow
        label={t("payment.total")}
        value={formatAmount(totalPayment, currency)}
        isHighlighted
        isNumeric
        labelClassName="font-medium text-foreground"
        valueClassName="text-primary"
      /> */}
    </InfoSection>
  );
}
